import styled, { css } from 'styled-components';
export const SelectFieldWrapper = styled.div `
  ${({ theme, $state, $isOpen }) => css `
    ${theme.getFontStyle('samsung-400-14')};
    border: 1px solid
      ${$isOpen
    ? theme.getColor('black', 'default')
    : $state === 'error'
        ? theme.getColor('error', 'default')
        : theme.getColor('gray', '05')};
    border-radius: 8px;
    background-color: ${theme.getColor('white')};
    color: ${theme.getColor('black')};
    &::placeholder {
      color: ${theme.getColor('gray', '03')};
    }
  `};
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
`;
export const SelectFieldBox = styled.select `
  flex: 1;
  height: 100%;
`;
export const SelectFieldOption = styled.option ``;
//# sourceMappingURL=SelectField.styles.js.map